import React, { useState, useEffect } from 'react';

// Importa las funciones de conexión
import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from '../../utilities/BL/Zones';

// Importa el componente visual hijo
import { Cards as CardsOverlay } from './Overlays/Cards';

// Corrección: Importamos GetCardsState desde el BL de disciplina que creamos
import { GetCardsState } from '../../utilities/BL/Cards';

/**
 * COMPONENTE: CARDS OVERLAY (PARENT CONTAINER)
 * ------------------------------------------------------------------
 * Este componente es el "Cerebro" del Overlay. 
 * 1. Establece la conexión WebSocket como "overlay:cards".
 * 2. Escucha los mensajes entrantes y los delega al hijo.
 * ------------------------------------------------------------------
 */
const Cards = () => {
    // --- ESTADOS DE CONEXIÓN Y DATOS ---
    const [cardsData, setCardsData] = useState(null);
    const [connectionStatus, setConnectionStatus] = useState('idle');

    // -------------------------------------------------------------------------
    // CICLO DE VIDA: CONEXIÓN Y DESCONEXIÓN
    // -------------------------------------------------------------------------
    useEffect(() => {
        // Hidratación inicial silenciosa
        const loadInitialData = async () => {
            const res = await GetCardsState();
            if (res.success && res.data) {
                // Solo cargamos el estado inicial en memoria, no disparamos animación
                setCardsData({ type: 'cards.state_update', data: res.data });
            }
        };
        
        const connect = async () => {
            await ConnectWebSocketForOverlay(
                'cards', 
                (status) => setConnectionStatus(status),
                (msg) => console.log('[Cards Overlay] Toast:', msg) 
            );
            SetSocketMessageHandler(handleIncomingMessage);
        };

        const handleIncomingMessage = (message) => {
            if (!message || !message.type) return;

            // Escuchamos actualizaciones en frío y los "triggers" que disparan la animación
            if (message.type === 'cards.state_update' || message.type === 'cards.trigger_overlay') {
                setCardsData(prev => {
                    // Evitamos re-renderizados innecesarios si la data es idéntica
                    if (JSON.stringify(prev) === JSON.stringify(message)) return prev;
                    return { ...message };
                });
            }
        };

        loadInitialData();
        connect();

        return () => {
            ClearSocketMessageHandler();
            DisconnectWebSocket();
        };
    }, []);

    return (
        <>
            <CardsOverlay data={cardsData} />

            {connectionStatus === 'error' && (
                <div style={{ position: 'fixed', bottom: 0, right: 0, background: 'red', color: 'white', padding: 5, fontSize: 10, zIndex: 9999 }}>D</div>
            )}
        </>
    );
};

export { Cards };